// Factory for the dedicated search pages. Each page file under src/pages/
// stays ~3 lines: export the GSSP and the component this module builds from
// the slug's registry entry. All behavior differences between pages live in
// src/config/searchPages.js, never in the page files.

import { searchPages } from "@/config/searchPages";
import BuscarLayout from "@/pages/Buscar/BuscarLayout";

import { getSessionAndFavorites } from "./getSessionAndFavorites";
import { pageDefaultsFrom, parseSearchQuery } from "./parseSearchQuery";

export { pageDefaultsFrom };

export const makeSearchPageGssp = (slug) => {
    const config = searchPages[slug];
    return async (context) => {
        if (!config) return { notFound: true };
        if (config.status === "redirect") {
            return { redirect: { destination: "/Buscar", permanent: true } };
        }
        const initialParams = parseSearchQuery(context.query, pageDefaultsFrom(config));
        const { session, favorites } = await getSessionAndFavorites(context);
        return { props: { initialParams, favorites, session } };
    };
};

export const makeSearchPage = (slug) => {
    const config = searchPages[slug] ?? null;
    const SearchPage = ({ initialParams, favorites, session }) => (
        <BuscarLayout
            initialParams={initialParams}
            favorites={favorites}
            session={session}
            config={config}
        />
    );
    SearchPage.displayName = `SearchPage(${slug})`;
    return SearchPage;
};
